<template>
    <ul class="aliPay">
        <li>
            <span>真实姓名</span>
            <input type="text" placeholder="请输入真实姓名" v-model="userInfo.real_name" disabled>
        </li>
        <li>
            <span>交易密码</span>
            <input type="text" placeholder="请输入交易密码" v-model="paypassword">
        </li>
        <li>
            <span>支付宝账号</span>
            <input type="text" placeholder="请输入支付宝账号" v-model="aliAccount">
        </li>
        <li style="align-items: flex-start">
            <span>收款二维码</span>
            <van-uploader :after-read="afterRead">
                <img :src="erCode ? this.imgBaseUrl+erCode : defaultImg" class="uploadImg" alt=""/>
            </van-uploader>
        </li>
        <button @click="submit">提交</button>
    </ul>
</template>

<script>
    import defaultImg from "../../../assets/img/uploadimg.png"
    import {mapState} from "vuex"

    export default {
        props: {
            aliInfo: {
                default: null
            }
        },
        name: "aliPay",
        data() {
            return {
                defaultImg,
                aliAccount: "",
                paypassword: "",
                erCode: "",
                status: 1,
            }
        },
        created() {
            if (this.aliInfo) {
                this.aliAccount = this.aliInfo.alipay;
                this.erCode = this.aliInfo.code;
            }
        },
        watch: {
            aliInfo() {
                this.aliAccount = this.aliInfo.alipay;
                this.erCode = this.aliInfo.code;
            }
        },
        computed: {
            ...mapState(["userInfo"])
        },
        methods: {
            afterRead(file) {
                // 此时可以自行将文件上传至服务器
                console.log(file);
                let data = new FormData();
                data.append("file_path", "upload/sign/");
                data.append("file_upload", file.file);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };
                this.ajax.post('appapi/Uploade/uploadFile', data, config).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                        this.erCode = res.data.data;
                        console.log("erCode", this.erCode);
                    }
                })
            },
            submit() {
                let data = new FormData();
                data.append("alipay", this.aliAccount);
                data.append("code", this.erCode);
                data.append("paypassword", this.paypassword);
                data.append("status", this.status);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };
                this.ajax.post('appapi/c2c/setAlipay', data, config).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .aliPay {
        padding: 0 39px;
        background: #fff;

        li {
            display: flex;
            align-items: center;
            padding: 44px 0 29px;
            border-bottom: 1px solid #F1F1F1;

            &:last-child {
                border: none;
            }

            span {
                display: inline-block;
                width: 160px;
                margin-right: 54px;
                font-size: 30px;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
            }

            input {
                border: none;
                outline: none;
                font-size: 24px;
            }

            .uploadImg {
                width: 184px;
                height: 184px;
            }
        }

        button {
            width: 100%;
            height: 86px;
            margin: 36px 0;
            font-size: 30px;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            background: rgba(31, 194, 109, 1);
            border-radius: 10px;
        }
    }
</style>
